// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__Stc7T","calendarButtons":"ClockData_calendarButtons__2E6MG"};